import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const OldValue = ({ value }) => {
    return (
        <>
            <span className="px-3 py-1 rounded old-value-style">{value}</span>
            <FontAwesomeIcon className="text-muted mx-1" icon={faArrowRight} />
        </>
    );
};